import React, { useState, useEffect } from 'react';
import { useHRMS } from '../context/HRMSContext.jsx';
import api from '../services/api.js';
import Message from '../components/Message.jsx';
import PermissionGuard from "../components/PermissionGuard.jsx";
import { MODULES, ACTIONS } from "../context/PermissionsContext.jsx";
import CommonTable from "../components/common/CommonTable.jsx";
function LeaveTypeMaster() {
  const { state, loadLeaveTypes } = useHRMS();
  const [showModal, setShowModal] = useState(false);
  const [editingLeaveType, setEditingLeaveType] = useState(null);
  const [formData, setFormData] = useState({
    leaveName: '',
    paidUnpaid: 'Paid',
    maxPerYear: '',
    byExperience: false,
    experienceRanges: [{
      experienceFrom: '',
      experienceTo: '',
      experienceMaxPerYear: ''
    }]
  });
  const [message, setMessage] = useState({ text: '', type: '' });
  const [showFilters, setShowFilters] = useState(false);

const [leaveTypeFilters, setLeaveTypeFilters] = useState({
  leaveName: "",
  type: "",
});

  useEffect(() => {
    loadLeaveTypes();
  }, []);

  //console.log('LeaveTypes state:', state.leaveTypes);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Check for duplicate leave type name
    const existingLeaveType = (state.leaveTypes || []).find(leaveType => 
      leaveType.leaveName.toLowerCase() === formData.leaveName.toLowerCase() &&
      (!editingLeaveType || leaveType.id !== editingLeaveType.id)
    );
    
    if (existingLeaveType) {
      setMessage({ text: 'Leave type name already exists!', type: 'error' });
      return;
    }
    
    // Validate experience ranges
    if (formData.byExperience) {
      for (let i = 0; i < formData.experienceRanges.length; i++) {
        const range = formData.experienceRanges[i];
        if (!range.experienceMaxPerYear || !range.experienceFrom) {
          setMessage({ text: `Please fill all required fields for range ${i + 1}!`, type: 'error' });
          return;
        }
        if (range.experienceFrom && range.experienceTo && 
            parseInt(range.experienceFrom) > parseInt(range.experienceTo)) {
          setMessage({ text: `From experience must be less than To experience in range ${i + 1}!`, type: 'error' });
          return;
        }
      }
    }
    
    try {
      const submitData = {
        leaveName: formData.leaveName,
        paidUnpaid: formData.paidUnpaid,
        maxPerYear: formData.byExperience ? 0 : parseInt(formData.maxPerYear),
        byExperience: formData.byExperience,
        experienceRanges: formData.byExperience ? formData.experienceRanges.map(range => ({
          experienceFrom: parseInt(range.experienceFrom) || 0,
          experienceTo: range.experienceTo && range.experienceTo !== '' ? parseInt(range.experienceTo) : null,
          experienceMaxPerYear: parseInt(range.experienceMaxPerYear)
        })) : []
      };

      if (editingLeaveType) {
        await api.leaveTypes.update(editingLeaveType.id, submitData);
        setMessage({ text: 'Leave type updated successfully!', type: 'success' });
      } else {
        await api.leaveTypes.create(submitData);
        setMessage({ text: 'Leave type created successfully!', type: 'success' });
      }
      loadLeaveTypes();
      resetForm();
    } catch (error) {
      console.error('Error saving leave type:', error);
      setMessage({ text: 'Error saving leave type!', type: 'error' });
    }
  };

  const resetForm = () => {
    setFormData({
      leaveName: '',
      paidUnpaid: 'Paid',
      maxPerYear: '',
      byExperience: false,
      experienceRanges: [{
        experienceFrom: '',
        experienceTo: '',
        experienceMaxPerYear: ''
      }]
    });
    setShowModal(false);
    setEditingLeaveType(null);
  };

  const handleEdit = (leaveType) => {
    setEditingLeaveType(leaveType);
    
    // Handle experience ranges - use new format if available, fallback to old format
    let experienceRanges = [];
    if (leaveType.experienceRanges && leaveType.experienceRanges.length > 0) {
      experienceRanges = leaveType.experienceRanges.map(range => ({
        experienceFrom: range.experienceFrom ? range.experienceFrom.toString() : '',
        experienceTo: range.experienceTo !== null && range.experienceTo !== undefined ? range.experienceTo.toString() : '',
        experienceMaxPerYear: range.experienceMaxPerYear ? range.experienceMaxPerYear.toString() : ''
      }));
    } else if (leaveType.byExperience) {
      // Fallback to old single range format
      experienceRanges = [{
        experienceFrom: leaveType.experienceFrom ? leaveType.experienceFrom.toString() : '',
        experienceTo: leaveType.experienceTo !== null && leaveType.experienceTo !== undefined ? leaveType.experienceTo.toString() : '',
        experienceMaxPerYear: leaveType.experienceMaxPerYear ? leaveType.experienceMaxPerYear.toString() : ''
      }];
    } else {
      experienceRanges = [{
        experienceFrom: '',
        experienceTo: '',
        experienceMaxPerYear: ''
      }];
    }
    
    setFormData({
      leaveName: leaveType.leaveName,
      paidUnpaid: leaveType.paidUnpaid,
      maxPerYear: leaveType.byExperience ? '' : (leaveType.maxPerYear ? leaveType.maxPerYear.toString() : ''),
      byExperience: leaveType.byExperience || false,
      experienceRanges: experienceRanges
    });
    setShowModal(true);
  };
const filteredLeaveTypes = (state.leaveTypes || []).filter((leaveType) => {

  const matchesLeaveName =
    !leaveTypeFilters.leaveName ||
    leaveType.leaveName
      .toLowerCase()
      .includes(leaveTypeFilters.leaveName.toLowerCase());

  const matchesType =
    !leaveTypeFilters.type ||
    leaveType.paidUnpaid === leaveTypeFilters.type;

  return matchesLeaveName && matchesType;
});
  const handleDelete = async (id) => {
    if (window.confirm('Are you sure?')) {
      try {
        await api.leaveTypes.delete(id);
        loadLeaveTypes();
        setMessage({ text: 'Leave type deleted successfully!', type: 'success' });
      } catch (error) {
        console.error('Error deleting leave type:', error);
        setMessage({ text: 'Error deleting leave type!', type: 'error' });
      }
    }
  };

  return (
    <PermissionGuard module={MODULES.LEAVE_TYPES} action={ACTIONS.VIEW} submodule={MODULES.LEAVE_TYPES.submodules.LEAVE_TYPE_MASTER}>
      <div className="leave-type-master">
      {message.text && (
        <Message 
          message={message.text} 
          type={message.type} 
          onClose={() => setMessage({ text: '', type: '' })} 
        />
      )}
      <div className="d-flex justify-content-between align-items-center mb-1">
  <h2 className='hd_a'>Leave Type Master</h2>

  <div className="d-flex align-items-center gap-2">

    <button
      type="button"
      className={`btn ${
        Object.values(leaveTypeFilters).some(v => v !== "")
          ? "btn-primary"
          : "btn-outline-primary"
      }`}
      onClick={() => setShowFilters(!showFilters)}
    >
      <i className="bi bi-funnel"></i>
    </button>

    <PermissionGuard
      module={MODULES.LEAVE_TYPES}
      action={ACTIONS.CREATE}
      submodule={MODULES.LEAVE_TYPES.submodules.LEAVE_TYPE_MASTER}
    >
      <button
        className="btn btn-primary"
        onClick={() => setShowModal(true)}
      >
        <i className="bi bi-plus-lg me-1"></i>Add Leave Type
      </button>
    </PermissionGuard>

  </div>
</div>
        {/* <h2 className='hd_a'>Leave Type Master</h2>
        <PermissionGuard module={MODULES.LEAVE_TYPES} action={ACTIONS.CREATE} submodule={MODULES.LEAVE_TYPES.submodules.LEAVE_TYPE_MASTER}>
          <button className="btn btn-primary" onClick={() => setShowModal(true)}>
            <i className="bi bi-plus-lg me-1"></i>Add Leave Type
          </button>
        </PermissionGuard>
      </div> */}


{showFilters && (
  <div className="card shadow-sm mb-3">
    <div className="card-body py-2">
      <div className="row g-3">

        <div className="col-md-4">
          <label className="form-label">Leave Name</label>

          <input
            type="text"
            className="form-control"
            placeholder="Search leave name"
            value={leaveTypeFilters.leaveName}
            onChange={(e) =>
              setLeaveTypeFilters({
                ...leaveTypeFilters,
                leaveName: e.target.value,
              })
            }
          />
        </div>

        <div className="col-md-4">
          <label className="form-label">Type</label>

          <select
            className="form-control"
            value={leaveTypeFilters.type}
            onChange={(e) =>
              setLeaveTypeFilters({
                ...leaveTypeFilters,
                type: e.target.value,
              })
            }
          >
            <option value="">All</option>
            <option value="Paid">Paid</option>
            <option value="Unpaid">Unpaid</option>
          </select>
        </div>

        <div className="col-md-2 d-flex align-items-end">
          <button
            type="button"
            className="btn btn-outline-primary w-100"
            onClick={() =>
              setLeaveTypeFilters({
                leaveName: "",
                type: "",
              })
            }
          >
            Clear
          </button>
        </div>

      </div>
    </div>
  </div>
)}

      {showModal && (
        <div className="modal" style={{display: 'block', backgroundColor: 'rgba(0,0,0,0.3)'}}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content shadow-sm border-0">
              <div className="modal-header border-bottom pt-2 pr-0 pb-2" style={{backgroundColor: 'var(--primary-light)'}}>
                <h6 className="modal-title" style={{color: 'var(--primary-color)'}}>{editingLeaveType ? 'Edit' : 'Add'} Leave Type</h6>
                <button type="button" className="btn-close" onClick={resetForm}></button>
              </div>
              <form onSubmit={handleSubmit}>
                <div className="modal-body p-3">
                  <div className="row g-2">
                    <div className="col-4">
                      <label className="form-label small text-muted">Leave Name *</label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        value={formData.leaveName}
                        onChange={(e) => setFormData({...formData, leaveName: e.target.value})}
                        required
                      />
                    </div>
                    <div className="col-4">
                      <label className="form-label small text-muted">Type *</label>
                      <select
                        className="form-select form-select-sm"
                        value={formData.paidUnpaid}
                        onChange={(e) => setFormData({...formData, paidUnpaid: e.target.value})}
                        required
                      >
                        <option value="Paid">Paid</option>
                        <option value="Unpaid">Unpaid</option>
                      </select>
                    </div>
                    <div className="col-4">
                      <label className="form-label small text-muted">Max Per Year {!formData.byExperience && '*'}</label>
                      <input
                        type="number"
                        className="form-control form-control-sm"
                        value={formData.maxPerYear}
                        onChange={(e) => setFormData({...formData, maxPerYear: e.target.value})}
                        placeholder="Enter number"
                        required={!formData.byExperience}
                        disabled={formData.byExperience}
                      />
                      {/* {!formData.byExperience && (
                        <button 
                          type="button" 
                          className="btn btn-sm btn-outline-success mt-1 w-100"
                          onClick={() => {
                            // Copy current form data and reset for new entry
                            const currentData = {
                              leaveName: formData.leaveName,
                              paidUnpaid: formData.paidUnpaid,
                              maxPerYear: formData.maxPerYear
                            };
                            // Reset form but keep copied values as reference
                            setFormData({
                              ...formData,
                              leaveName: formData.leaveName + ' (Copy)',
                              maxPerYear: formData.maxPerYear
                            });
                          }}
                          title="Copy current values to create similar leave type"
                        >
                          + Copy & Add New
                        </button>
                      )} */}
                    </div>
                    <div className="col-12">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="byExperience"
                          checked={formData.byExperience}
                          onChange={(e) => setFormData({...formData, byExperience: e.target.checked})}
                        />
                        <label className="form-check-label small text-muted" htmlFor="byExperience">
                          Experience-based Leave (Check worker's joining date)
                        </label>
                      </div>
                    </div>
                    {formData.byExperience && (
                      <>
                        <div className="col-12">
                          <div className="alert alert-info py-2 mb-2">
                            <small><strong>Experience-based Leave:</strong> Workers can only apply if their experience (from joining date) falls within the specified range.</small>
                          </div>
                        </div>
                        {formData.experienceRanges.map((range, index) => (
                          <React.Fragment key={index}>
                            <div className="col-4">
                              <label className="form-label small text-muted">Max Per Year *</label>
                              <input
                                type="number"
                                className="form-control form-control-sm"
                                value={range.experienceMaxPerYear}
                                onChange={(e) => {
                                  const newRanges = [...formData.experienceRanges];
                                  newRanges[index].experienceMaxPerYear = e.target.value;
                                  setFormData({...formData, experienceRanges: newRanges});
                                }}
                                placeholder="Enter number"
                                required
                              />
                            </div>
                            <div className="col-4">
                              <label className="form-label small text-muted">From (Years) *</label>
                              <input
                                type="number"
                                className="form-control form-control-sm"
                                value={range.experienceFrom === '' || range.experienceFrom == null ? 0 : range.experienceFrom}
                                onChange={(e) => {
                                  const newRanges = [...formData.experienceRanges];
                                  newRanges[index].experienceFrom = e.target.value === '' ? 0 : Number(e.target.value);
                                  setFormData({...formData, experienceRanges: newRanges});
                                }}
                                min="0"
                                placeholder="e.g. 1"
                                required
                              />
                            </div>
                            <div className="col-4">
                              <label className="form-label small text-muted">To (Years)</label>
                              <input
                                type="number"
                                className="form-control form-control-sm"
                                value={range.experienceTo}
                                onChange={(e) => {
                                  const newRanges = [...formData.experienceRanges];
                                  newRanges[index].experienceTo = e.target.value;
                                  setFormData({...formData, experienceRanges: newRanges});
                                }}
                                min={range.experienceFrom || "0"}
                                placeholder="Leave empty for 10+ years"
                              />
                              <small className="text-muted">Leave empty for unlimited (e.g., 10+ years)</small>
                              <div className="mt-1">
                                {index === formData.experienceRanges.length - 1 && (
                                  <button 
                                    type="button" 
                                    className="btn btn-sm btn-outline-primary me-1"
                                    onClick={() => {
                                      const newRange = {
                                        experienceMaxPerYear: '',
                                        experienceFrom: range.experienceTo ? (parseInt(range.experienceTo) + 1).toString() : '',
                                        experienceTo: ''
                                      };
                                      setFormData({
                                        ...formData, 
                                        experienceRanges: [...formData.experienceRanges, newRange]
                                      });
                                    }}
                                    title="Add new experience range"
                                  >
                                    + Add Range
                                  </button>
                                )}
                                {formData.experienceRanges.length > 1 && (
                                  <button 
                                    type="button" 
                                    className="btn btn-sm btn-outline-danger"
                                    onClick={() => {
                                      const newRanges = formData.experienceRanges.filter((_, i) => i !== index);
                                      setFormData({...formData, experienceRanges: newRanges});
                                    }}
                                    title="Remove this range"
                                  >
                                    Remove
                                  </button>
                                )}
                              </div>
                            </div>
                          </React.Fragment>
                        ))}
                      </>
                    )}
                  </div>
                </div>
                <div className="modal-footer bg-light py-2">
                  <button type="submit" className="btn btn-sm btn-primary">
                    Save
                  </button>
                  <button type="button" className="btn btn-sm btn-outline-secondary" onClick={resetForm}>
                    Close
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      <div className="card">
        <div className="card-body px-0 pt-0">
          <CommonTable
            dataSource={api.leaveTypes.table}
            queryParams={{ leaveName: leaveTypeFilters.leaveName, paidUnpaid: leaveTypeFilters.type }}
            columns={[
              { key: 'leaveName', label: 'Leave Name', sortable: true },
              { key: 'paidUnpaid', label: 'Type', sortable: true, render: (value, leaveType) => <span className={`badge ${value === 'Paid' ? 'bg-success' : 'bg-warning'}`}>{value}</span> },
              { key: 'maxPerYear', label: 'Max/Year', sortable: true, render: (value, leaveType) => leaveType.byExperience ? <div>{leaveType.experienceRanges?.length ? leaveType.experienceRanges.map(range => range.experienceMaxPerYear).join(', ') + ' days' : (leaveType.experienceMaxPerYear || 0) + ' days'}</div> : leaveType.maxPerYear },
              { key: 'experience', label: 'Experience', sortable: false, render: (value, leaveType) => leaveType.byExperience ? <div>{leaveType.experienceRanges?.length ? leaveType.experienceRanges.map((range, idx) => <span key={idx} className="badge bg-info me-1 mb-1 d-block">{range.experienceFrom}-{range.experienceTo || '∞'} years ({range.experienceMaxPerYear} days)</span>) : <span className="badge bg-info">{leaveType.experienceFrom}-{leaveType.experienceTo || '∞'} years</span>}</div> : <span className="text-muted">-</span> }
            ]}
            renderActions={(leaveType) => <>
              <PermissionGuard module={MODULES.LEAVE_TYPES} action={ACTIONS.EDIT} submodule={MODULES.LEAVE_TYPES.submodules.LEAVE_TYPE_MASTER}>
                <button title='Edit' className="btn btn-sm btn-primary me-1" onClick={() => handleEdit(leaveType)} style={{ fontSize: '13px', padding: '4px 10px' }}><i className="bi bi-pencil-square"></i></button>
              </PermissionGuard>
              <PermissionGuard module={MODULES.LEAVE_TYPES} action={ACTIONS.DELETE} submodule={MODULES.LEAVE_TYPES.submodules.LEAVE_TYPE_MASTER}>
                <button title='Delete' className="btn btn-sm btn-danger" onClick={() => handleDelete(leaveType.id)} style={{ fontSize: '13px', padding: '4px 10px' }}><i className="bi bi-trash-fill"></i></button>
              </PermissionGuard>
            </>}
          />
        </div>
      </div>
      </div>
    </PermissionGuard>
  );
}

export default LeaveTypeMaster;